export const dashboard = {
  overview: 'نظرة عامة',
  vehicles: 'المركبات',
  clients: 'العملاء',
  bookings: 'الحجوزات',
  calendar: 'التقويم',
  contracts: 'العقود',
  invoices: 'الفواتير والمدفوعات',
  reports: 'التقارير',
  settings: 'الإعدادات',
  agencySettings: 'إعدادات الوكالة',
  profileSettings: 'إعدادات الملف الشخصي',
  agencyPanel: 'لوحة الوكالة',
  agency: 'الوكالة',
  noAgency: 'لم يتم العثور على وكالة',
  createAgencyFirst: 'يجب عليك إنشاء وكالة أولاً للوصول إلى لوحة التحكم.',
  createAgency: 'إنشاء وكالة',
  
  // Overview
  activeRentals: 'الإيجارات النشطة',
  availableVehicles: 'المركبات المتاحة',
  totalClients: 'إجمالي العملاء',
  pendingPayments: 'المدفوعات المعلقة',
  monthlyRevenue: 'الإيرادات الشهرية',
  yearlyRevenue: 'الإيرادات السنوية',
  upcomingPickups: 'الاستلامات القادمة',
  upcomingReturns: 'الإرجاعات القادمة',
  totalVehicles: 'إجمالي المركبات',
  notifications: 'الإشعارات والتنبيهات',
  quickActions: 'إجراءات سريعة',
  addVehicle: 'إضافة مركبة',
  addVehicleDesc: 'إضافة مركبة جديدة إلى أسطولك',
  newBooking: 'حجز جديد',
  newBookingDesc: 'إنشاء حجز تأجير جديد',
  addClient: 'إضافة عميل',
  addClientDesc: 'إضافة عميل جديد إلى قاعدة البيانات',
  upcomingPickupsMessage: 'لديك {{count}} استلام قادم هذا الأسبوع',
  upcomingReturnsMessage: 'لديك {{count}} إرجاع قادم هذا الأسبوع',
  pendingPaymentsMessage: 'لديك {{count}} دفعة معلقة للتحصيل',
  
  // Empty states
  noCarsYet: 'لا توجد مركبات بعد',
  noCarsYetDesc: 'لم تقم بإضافة أي مركبات إلى أسطولك بعد. أضف مركبتك الأولى لبدء إدارة أعمال التأجير الخاصة بك.',
  addFirstVehicle: 'أضف مركبتك الأولى',
  addFirstVehicleMessage: 'ابدأ بإضافة مركبتك الأولى',
  welcomeToAgency: 'مرحباً بك في لوحة تحكم وكالتك!',
  
  // Setup steps 
  step1: 'الخطوة 1',
  step1Desc: 'أضف مركباتك مع الصور والتفاصيل',
  step2: 'الخطوة 2',
  step2Desc: 'قم بتكوين أسعارك والتوفر',
  step3: 'الخطوة 3',
  step3Desc: 'ابدأ في تلقي الحجوزات',
  
  // Dashboard overview
  activityOverview: 'نظرة عامة على نشاطك والمؤشرات الرئيسية',
  newContract: 'عقد جديد',
  vehiclePlanning: 'تخطيط المركبات',
  statisticsAnalytics: 'الإحصائيات والتحليلات',
  detailedAnalysis: 'تحليل مفصل لأدائك والمؤشرات الرئيسية',
  vehicleStatus: 'حالة المركبات',
  bookingStatus: 'حالة الحجوزات',
  categoryPerformance: 'أداء الفئات',
}; 